<template >
  <v-dialog id="urtDialog" persistent v-model="getDialog" max-width="700">
      <v-card>
        <v-card-title class="headline">
            <span>Time:{{getData.time}}</span>
            <v-spacer></v-spacer>
            <v-btn @click.prevent="close()" text icon small>
               <v-icon>clear</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
          <vue-json-pretty
              :path="'res'"
              :data="getData.data"
              showLength
              showLine
              showDoubleQuotes
              :deep="5"
              highlightMouseoverNode
              highlightSelectedNode
              >
            </vue-json-pretty>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>
<script>
  import VueJsonPretty from 'vue-json-pretty'

  export default {
    id: "#urtDialog",
    props: {
      data : {
        type: Object,
        required: true,
        default: function(){
          return {
            dialogData : {}
          }
        }
      },
      dialog: {
        type: Boolean
      }
    },
    computed: {
      getData() {
        return this.data || {};
      },
      getDialog(){
        return this.dialog;
      }
    },
    methods: {
      close() {
        this.$emit('closeDialog', false);
      }
    },
    components: {
       VueJsonPretty
    }

  }
</script>

<style scoped>
.headline{
    font-size: 12pt !important;
    color: #056e97;
    font-weight: bold;
    padding-bottom: 0;
    padding: 1px;
}
</style>